import {Component, Input} from '@angular/core';
import {ViewInfoBlock, ViewInfoBlockItem} from './view-info-block.models';

@Component({
  selector: 'app-view-info-block',
  templateUrl: './view-info-block.component.html',
  styleUrls: ['./view-info-block.component.scss'],
})
export class ViewInfoBlockComponent {
  infoData!: ViewInfoBlock;

  hasDescription(item: ViewInfoBlockItem): boolean {
    return !!item.description;
  }

  hasValidLink(item: ViewInfoBlockItem): boolean {
    return !!(
      item.link &&
      item.link.url &&
      item.link.description
    );
  }

  hasValidColumns(item: ViewInfoBlockItem): boolean {
    return Array.isArray(item.columns) &&
      item.columns.some(c => !!c.title && !!c.description);
  }

  @Input() set data(model: ViewInfoBlock) {
    let filteredItems = [];
    if (model && model.items && model.items.length) {
      filteredItems = model.items.filter(item =>
        this.hasDescription(item) ||
        this.hasValidLink(item) ||
        this.hasValidColumns(item)
      );
    }
    if (filteredItems.length) {
      this.infoData = {
        title: model.title,
        items: filteredItems,
      };
    }
  }
}
